// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__Wqc4w","errors":"Errors_errors__kBNcv"};